import { useEffect, useState } from "react";
import InputField from "../../common/InputField";
import { MdClose } from "react-icons/md";
import { AnimatePresence, motion } from "framer-motion";
import Button from "../../common/Button";
import { IoMdClose } from "react-icons/io";
import { FaPaperPlane } from "react-icons/fa";
import { unitConversionAPI } from "../../utlis/apiService";

const PackingForm = ({
  initialData,
  onSave,
  onCancel,
  isEditing,
  setFormData,
  formData,
}) => {
  const today = new Date().toISOString()?.split("T")[0];
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [isUnitConvData, setIsUnitConvData] = useState([]);

  useEffect(() => {
    const fetchUnitConvData = async () => {
      try {
        const res = await unitConversionAPI.getAll();
        setIsUnitConvData(
          res.data.map((u) => ({
            value: u.unit_Conv_Id,
            label: u.unit_Conv_Name,
            raw: u.conv_Value,
          }))
        );
      } catch (err) {
        console.error("Error loading dropdowns", err);
      }
    };
    fetchUnitConvData();
  }, []);

  useEffect(() => {
    if (initialData) {
      const updatedForm = {
        bundle_No: initialData.bundle_No || "0",
        packing_Date: initialData.packing_Date
          ? initialData.packing_Date.split("T")[0]
          : today,
        order_No: initialData.order_No || "",
        dieNumber: initialData.dieNumber || "",
        die_Id: initialData.die_Id ?? null,
        batch_Id: initialData.batch_Id || "",
        casting_No: initialData.casting_No || "",
        cut_Length: initialData.cut_Length || "",
        wt_12_FT: initialData.wT_12_FT || "",
        wt_Cut_Length: initialData.wT_Cut_Length || "",
        pcs: initialData.pcs || "",
        total_Weight: initialData.total_Weight || "",
        series_Name: initialData.series_Name || "",
        remark: initialData.remark || "",
        unit_Conv_Id: initialData.unit_Conv_Id || "",
        final_CutLength_weight: initialData.final_CutLength_weight || "",
        // bundle_Pcs: initialData.bundle_Pcs || "",
        // bundle_Weight: initialData.bundle_Weight || "",
      };

      setFormData(updatedForm);
    }
  }, [initialData]);

  const calculateWt12FT = (pcs, totalWeight, cutLength) => {
    if (pcs && totalWeight && cutLength) {
      const result = ((totalWeight / pcs) * 12) / cutLength;
      return isNaN(result) ? "" : result.toFixed(2);
    }
    return "";
  };

const handleChange = (e, field) => {
  const value = typeof e === "object" && e?.target ? e.target.value : e;

  const updatedForm = {
    ...formData,
    [field]: value,
  };

  const pcs = parseFloat(field === "pcs" ? value : formData.pcs || 0);
  const totalWeight = parseFloat(
    field === "total_Weight" ? value : formData.total_Weight || 0
  );
  const cutLength = parseFloat(
    field === "cut_Length" ? value : formData.cut_Length || 0
  );

  updatedForm.wt_12_FT = calculateWt12FT(pcs, totalWeight, cutLength);

  const selectedUnit = isUnitConvData.find(
    (u) => u.value === (field === "unit_Conv_Id" ? value : formData.unit_Conv_Id)
  );
  const convValue = selectedUnit?.raw || 1;

  const wt12FT = parseFloat(updatedForm.wt_12_FT || 0);
  const wtCutLength = parseFloat(
    field === "wt_Cut_Length" ? value : formData.wt_Cut_Length || 0
  );

 updatedForm.final_CutLength_weight =
  wt12FT && wtCutLength && convValue
    ? ((wt12FT * wtCutLength) / convValue).toFixed(2)
    : "";


  setFormData(updatedForm);
};


  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData, formData.bundle_No);
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-slate-800 bg-opacity-75 flex items-center justify-center p-2 sm:p-4 z-9999">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30,
            duration: 0.5,
          }}
          className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[95vh] overflow-y-auto"
        >
          <div className="bg-primary text-white flex justify-between items-center p-4 sm:p-4">
            <h2 className="text-2xl font-semibold ">
              Add New Packing Entry
            </h2>
            <Button
              onClick={onCancel}
              icon={MdClose}
              className="text-3xl "
            ></Button>
          </div>

          <form onSubmit={handleSubmit} className="p-4 sm:p-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <InputField
                label="BUNDLE NO"
                value={formData.bundle_No}
                disabled
              />
              <InputField label="Batch ID" value={formData.batch_Id} disabled />
              <InputField
                label="CASTING NO"
                value={formData.casting_No}
                disabled
              />
              <InputField label="ORDER NO" value={formData.order_No} disabled />
              <InputField
                label="DIE NUMBER"
                value={formData.dieNumber}
                disabled
              />
              <InputField
                label="CUT LENGTH"
                value={formData.cut_Length}
                disabled
              />

              <InputField
                type="date"
                label="PACKING DATE"
                value={formData.packing_Date}
                onChange={(val) => handleChange(val, "packing_Date")}
              />
            </div>

            <div className="space-y-4">
              {selectedOrderDetails && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 bg-slate-50 p-4 rounded border">
                  <div>
                    <label className="text-sm font-medium text-slate-600">
                      Total Quantity
                    </label>
                    <p className="mt-1 text-base font-semibold text-slate-800">
                      {selectedOrderDetails.total_Qty ?? "-"}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-slate-600">
                      Total Weight
                    </label>
                    <p className="mt-1 text-base font-semibold text-slate-800">
                      {selectedOrderDetails.total_Weight ?? "-"}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-slate-600">
                      Packing Instructions
                    </label>
                    <p className="mt-1 text-base text-slate-700 whitespace-pre-line">
                      {selectedOrderDetails.packing_Instructions || "-"}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-slate-600">
                      General Notes
                    </label>
                    <p className="mt-1 text-base text-slate-700 whitespace-pre-line">
                      {selectedOrderDetails.general_Notes || "-"}
                    </p>
                  </div>
                </div>
              )}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <InputField
                  label="Total Weight"
                  value={formData.total_Weight}
                  onChange={(val) => handleChange(val, "total_Weight")}
                />
                <InputField
                  label="PCS"
                  value={formData.pcs}
                  onChange={(val) => handleChange(val, "pcs")}
                />
                <InputField
                  label="WT/12 FT"
                  value={formData.wt_12_FT}
                  onChange={() => {}}
                  disabled
                />

                <InputField
                  label="Final Cut Length"
                  value={formData.wt_Cut_Length}
                  onChange={(val) => handleChange(val, "wt_Cut_Length")}
                />
                <InputField
                  type="select"
                  label="Unit"
                  options={isUnitConvData}
                  value={formData.unit_Conv_Id}
                  onChange={(val) => handleChange(val, "unit_Conv_Id")}
                />
                <InputField
                  label="Final Cut Length Weigth"
                  value={formData.final_CutLength_weight}
                  onChange={() => {}}
                  disabled
                />
                <InputField
                  label="Series Name"
                  value={formData.series_Name}
                  disabled
                />
                <InputField
                  label="Remark"
                  value={formData.remark}
                  onChange={(val) => handleChange(val, "remark")}
                />
              </div>
            </div>
            <div className="flex justify-end space-x-4 mt-4">
              <Button
                text="Cancel"
                className="bg-gray-100 hover:bg-gray-200 text-primary font-semibold text-md rounded-md p-2"
                iconSpacing="pr-1"
                borderColor="border border-gray-300"
                icon={IoMdClose}
                iconSize="w-6 h-6"
                onClick={onCancel}
              />

              <Button
                type="submit"
                text="Save"
                className="bg-orange text-black font-semibold text-md rounded-md p-2"
                iconSpacing="pr-2"
                icon={FaPaperPlane}
                iconSize="w-4 h-4"
                iconColor="text-black"
              />
            </div>
          </form>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default PackingForm;
